import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import '@/filters'
import '@/directives'
import * as Sentry from '@sentry/browser'
import { Notifier } from '@airbrake/browser'
import App from './App.vue'
import EventTracking from './helpers/event-tracking'
import PrettyMoney from './components/PrettyMoney'
import widgetOptions from './helpers/widget-options.js'

Vue.config.productionTip = false

// Global components
Vue.component('pretty-money', PrettyMoney)

// Sentry and Airbrake Error Tracking
if (process.env.VUE_APP_SENTRY_ENABLED) {
  const envType = process.env.NODE_ENV

  Sentry.init({
    dsn: 'https://b32e1a59a27f4b6da8bda999ba6e70e8@sentry.io/1393552',
    environment: process.env.NODE_ENV || 'development',
    integrations: [
      new Sentry.Integrations.Vue({
        Vue,
        attachProps: true
      })
    ]
  })

  if (envType !== 'development') {
    let airbrake = new Notifier({
      projectId: 359234,
      projectKey: 'dd668a526264d19f21ee60f5930deb83',
      environment: envType
    })
    Vue.config.errorHandler = function (err, vm, info) {
      airbrake.notify({
        error: err,
        params: { info: info }
      })
    }
  }
}

const transactionMonitor = Vue.observable({
  transactionEnded: false
})

Object.defineProperty(window, 'transaction', {
  get () {
    return transactionMonitor.transactionEnded
  },
  set (transaction) {
    transactionMonitor.transactionEnded = transaction
  }
})

window.onTransactionEnded = function (s, a, m) {
  if (s) {
    window.transaction = true
  } else {
    return false
  }
}

// Set to true while developing
Vue.config.devtools = process.env.VUE_APP_DEVTOOLS
Vue.prototype.widgetOptions = widgetOptions
Vue.prototype.eventTracking = EventTracking
new Vue({
  store,
  router,
  render: h => h(App),
  created: async function () {
    this.$store.dispatch('venue/loadInfo')

    await this.$store.dispatch('products/getAllProducts')

    // Load cart from local storage after products are all loaded
    // so we can check for and remove items that aren't available
    this.$store.dispatch('cart/loadCart')

    // get parent window info if in iframe
    if (window.self !== window.top) {
      this.$store.dispatch('iframe/syncIframeInfo')
    }
  }
}).$mount(`#${widgetOptions.config.element_id}`)
